import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { useNotification } from '../../../../hooks'
import { RentalPortalViewingFormModal } from '../../RentalPortalViewingFormModal'

export function useBookRentalPortalViewing({ onBooked } = EMPTY_OBJECT) {
  const { t } = useTranslation()

  const [modal, setModal] = useState(null)

  const { handleAddSuccessNotification } = useNotification()

  function handleCloseModal() {
    setModal(null)
  }

  async function handleBooked() {
    handleAddSuccessNotification('RentalPortal.ViewingBookedNotificationKey')

    return onBooked?.()
  }

  async function handleCreated(createdCount) {
    handleCloseModal()

    handleAddSuccessNotification(
      t('RentalPortal.ViewingsAddedNotificationKey', { count: createdCount })
    )

    return onBooked?.()
  }

  function handleOpenBookViewing({ applicant, listing } = EMPTY_OBJECT) {
    setModal(
      <RentalPortalViewingFormModal
        isBooking
        applicant={applicant}
        listing={listing}
        onBooked={handleBooked}
        onClose={handleCloseModal}
        onCreated={handleCreated}
      />
    )
  }

  return { bookViewingModal: modal, handleOpenBookViewing }
}
